module.exports = __webpack_public_path__ + "img/10n.5ec5eeb7.png";